module.exports = __webpack_public_path__ + "static/img/img_login_code.570a82c9.png";